import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { KpiTile } from "../components/indicadores/kpi";
import { TablaComparativa } from "../components/indicadores/TablaComparativa";
import { useHashHighlight } from "../components/indicadores/useHashHighlight";

export const GRUPOS = [
  { id: "ventas", titulo: "Ventas", keys: ["facturacion", "operaciones", "ticket_medio"] },
  { id: "libre-receta", titulo: "Venta libre vs receta", keys: ["venta_libre", "peso_venta_libre", "venta_receta"] },
  { id: "farmacia-parafarmacia", titulo: "Farmacia vs parafarmacia", keys: ["farmacia", "parafarmacia", "peso_parafarmacia"] },
  { id: "consejo", titulo: "Consejo", keys: ["ratio_consejo", "consejo_eur", "uds_libre_por_receta"] },
  { id: "tickets", titulo: "Tipos de ticket", keys: ["solo_receta", "mixtos", "solo_libre"] },
  { id: "rentabilidad", titulo: "Rentabilidad", keys: ["margen", "margen_pct", "margen_farmacia", "margen_pct_farmacia", "margen_parafarmacia", "margen_pct_parafarmacia"] },
  { id: "stock-parado", titulo: "Stock parado", keys: ["stock_parado_vendido", "ratio_d_muerto"] },
];

export function IndicadoresVentasSeccion({ data }) {
  const { hash } = useLocation();
  const comp = data?.comparativa;
  const active = useHashHighlight(!!comp);
  const filas = Object.fromEntries((comp?.filas || []).map((f) => [f.key, f]));
  useEffect(() => {
    if (hash === "#indicadores-ventas") document.getElementById("indicadores-ventas")?.scrollIntoView({ behavior: "smooth" });
  }, [hash]);
  if (!comp) return null;

  return (
    <section id="indicadores-ventas" className="mt-12 pt-8 border-t border-slate-200 fade-in" data-testid="indicadores-ventas-page">
      <img src="/img/farmanaliza-indicadores-ventas.jpg?v=2" alt="Farmanaliza · Indicadores de ventas: facturación, ticket medio y evolución"
           className="w-full max-w-5xl rounded-2xl shadow-sm h-auto mb-6" data-testid="indicadores-ventas-banner" />
      <h2 className="sr-only">Indicadores de ventas</h2>
      {GRUPOS.map((g) => (
        <section key={g.id} id={`grupo-${g.id}`} className="mb-6 scroll-mt-24" data-testid={`grupo-${g.id}`}>
          <h3 className="text-xs uppercase tracking-widest font-bold text-slate-400 mb-2">{g.titulo}</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {g.keys.filter((k) => filas[k]).map((k) => <KpiTile key={k} f={filas[k]} comp={comp} highlight={active === k} />)}
          </div>
        </section>
      ))}
      <TablaComparativa comp={comp} />
    </section>
  );
}

export function AccesosIndicadores() {
  const ir = (id) => document.getElementById(`grupo-${id}`)?.scrollIntoView({ behavior: "smooth", block: "start" });
  return (
    <nav className="flex flex-wrap gap-2 mb-6" data-testid="accesos-indicadores">
      <span className="text-xs uppercase tracking-widest font-bold text-slate-400 self-center mr-1">Ir a</span>
      {GRUPOS.map((g) => (
        <button key={g.id} type="button" onClick={() => ir(g.id)} data-testid={`acceso-${g.id}`}
                className="px-3 py-1.5 rounded-full border border-slate-200 bg-white text-xs font-semibold text-slate-700 hover:border-sky-400 hover:text-sky-800 transition-colors">
          {g.titulo}
        </button>
      ))}
    </nav>
  );
}
